var common = require("../../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('wechat-bind')
        ko.components.register('wechat-bind', {
            viewModel: function (params) {
                var $this = this;
                var random = common.urlSearch(location.href)["random"];
                var service = common.urlSearch(location.href)["service"];
                var login_style = "";
                if(localStorage.getItem("loginTemplate") === 'smallConcise'){
                    login_style = "login_style=IOA&";
                }
                $this.urlParam = '#/login?'+login_style+window.location.href.split('?')[1];
                $this.userKeypress = function (keyCode) {
                    if (keyCode == 13) {
                        $("input[type=password]").focus();
                    }
                }
                $this.keypress = function (keyCode) {
                    if (keyCode == 13) {
                        $this.login();
                    }
                }
                $this.loginBack = function (result,isAD){
                    if(result.data){
                        if(result.data.url){
                            common.redirectTo(result.data.url);
                        }
                        if(result.data.message&&result.data.message.replace(/^\s+|\s+$/g,"")){
                            if(isAD){
                                common.message("error",result.data.message);
                            }else{
                                common.errorAlert(result.data.message);
                            }
                        }
                    }else if(result.message){
                        common.errorAlert(result.message);
                    }else{
                        common.errorAlert(commonLocal.describe.AbnormalError);
                    }
                }
                $this.login = function(){
                    var postD = $('.pwdLogin input').serializeObject();
                    if (postD.password) {
                        var pwdType = {decryptType: "SM2"};
                        try {
                            pwdType.cryptKey = "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
                        } catch (error) {
                        }
                        console.info("postD.password", pwdType)
                        postD.password = common.sm2.doCrypt(pwdType.cryptKey, postD.password);
                    }
                    postD.random = random;
                    postD.service = service;
                    var searchUrl = window.location.href.split("?").splice(1,).join("");
                    common.fetch("/auth/qywx/scancode/login/pwd?"+searchUrl, {
                        type: "POST",
                        data: JSON.stringify(postD),
                        handleError: function (data) {
                        },
                        success: function (result) {
                            console.log(result)
                            $this.loginBack(result);
                        }
                    })
                }

            },
            template: require("./WechatBind.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/login/wechatBind/WechatBind.js
// module id = 124
// module chunks = 0